import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-loading">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#FF3366] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-sm text-[#52525B] font-body">Authenticating...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}
